import React from "react";
import styled from "styled-components";
import { HeadlineStyle } from "../TypographyStyle";

const HeadlineTxt = styled.h1`
  ${HeadlineStyle}
`;

const Headline = ({ children, className }) => {
  return <HeadlineTxt className={className}>{children}</HeadlineTxt>;
};

export default Headline;
